// noinspection JSUnusedGlobalSymbols

import type { LoaderFunction } from '@remix-run/node';
import { json } from '@remix-run/node'
import { Form, useLoaderData } from '@remix-run/react'
import { authenticator } from '~/services/auth.server'
import { APP_BUILD, APP_VERSION } from '~/services/version.server'
import * as React from 'react'
import {fill} from "@cloudinary/url-gen/actions/resize";
import {cloudinaryServer} from "@/services/cloudinary.server";

type LoaderData = {
    version: string
    build: string
    logoUrl: string
}

export const loader: LoaderFunction = async ({ request }) => {
    await authenticator.isAuthenticated(request, {
        successRedirect: '/me',
    })
    const logoUrl = cloudinaryServer
        .image('brand/pmg_logo_with_tagline_tigubk')
        .format('auto')
        .quality('auto')
        .resize(fill().width(350))
        .toURL()

    return json({
        version: APP_VERSION,
        build: APP_BUILD,
        logoUrl,
    })
}

const LoginBox = () => {
    const { version, build, logoUrl } = useLoaderData<LoaderData>()
    return (
        <div className="flex h-screen justify-center sm:items-center pt-8 sm:pt-0 lg:bg-gray-200">
            <div
                className='flex h-1/3 min-h-[400px] w-1/3 min-w-[200px] flex-col items-center justify-between bg-white p-8 lg:border-[20px] lg:border-primary'>
                <img src={logoUrl} alt='Logo' className='lg:w-1/2' />
                <p className='text-center text-gray-600 text-lg lg:text-xl'>Click here to log in to the PMG Operations
                    Dashboard</p>
                {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
                <button className='bg-primary rounded px-8 py-4 min-w-[200px] text-white'>LOGIN</button>
                <div className='mt-2 mx-auto text-sm text-center font-bold'>{version}-{build}</div>
            </div>
        </div>
    )
}

export default function Login() {
    return (
        <Form className='' action="/auth0" method="post">
            <LoginBox />
            {/*<button>Login with Auth0</button>*/}
        </Form>
    )
}
